module.exports = __webpack_public_path__ + "img/atlas-logo.676cc81a.png";